import React from 'react';
import { ThemeFactory } from "../ThemeFactory";
export var ThemeContext = /*#__PURE__*/React.createContext(ThemeFactory.defaultTheme);
ThemeContext.displayName = 'ThemeContext';
ThemeContext.__KONTUR_REACT_UI__ = 'ThemeContext';